export enum WeatherTrafficViewTypes {
    weatherCamLandingPage = 'weatherCamLandingPage',
    trafficCamLandingPage = 'trafficCamLandingPage',
    weatherCamDetailPage = 'weatherCamDetailPage',
    trafficCamDetailPage = 'trafficCamDetailPage',
    weatherCamCategoryPage = 'weatherCamCategoryPage'
}

export type CameraViewTypes = keyof typeof WeatherTrafficViewTypes;